import { AssetDoc } from '@livekatsomo/models';
import { UploadAssetFunction } from '@livekatsomo/types';
import { useEnvironment } from '@livekatsomo/web/hooks';
import CloseIcon from '@mui/icons-material/Close';
import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { TransitionProps } from '@mui/material/transitions';
import { JSONContent } from '@tiptap/react';
import { useTranslation } from 'next-i18next';
import { forwardRef } from 'react';
import { TipTapEditorForm } from '../EditorForm/EditorForm';

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface SummaryEditorDialogProps {
  assets: AssetDoc[];
  document?: JSONContent;
  open: boolean;
  title?: string;
  onClose: () => void;
  onSubmit: (document: JSONContent) => Promise<void>;
  onUploadAsset: UploadAssetFunction;
}

export function SummaryEditorDialog({
  assets,
  document,
  open,
  title,
  onClose,
  onSubmit,
  onUploadAsset,
}: SummaryEditorDialogProps) {
  const { development } = useEnvironment();
  const { t } = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: 'relative' }} color="default">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title ? title : t('Summary')}
          </Typography>
        </Toolbar>
      </AppBar>
      <DialogContent>
        <TipTapEditorForm
          onSubmit={onSubmit}
          document={document}
          onClose={onClose}
          onUploadAsset={onUploadAsset}
          debug={development}
          assets={assets}
        />
      </DialogContent>
    </Dialog>
  );
}
